import { useMutation, UseMutationResult } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface IForwardGeocodingData {
  street: string;
  city: string;
  state: string;
  zip_code: string;
  country: string;
}

const forwardGeocoding = (postData: IForwardGeocodingData) => {
  return http().post(endpoints.job.forwardGeocoding, postData);
};

export function useForwardGeocoding(options?: any): UseMutationResult<any, Error, IForwardGeocodingData> {
  return useMutation({ mutationFn: forwardGeocoding, ...options });
}
